import Chart from 'chart.js';

$(function() {
  let leadsChart;
  let leadsElement = document.getElementById('leads-chart');

  if (leadsElement) {
    $.ajax({
    	url: '/api/v1/charts/leads',
    	method: 'GET',
      data: {
        number_of_days: $('#statistic_period_for_chart').val()
      },
    	success: function (data) {
        leadsChart = new Chart(leadsElement, {
          type: 'line',
          data: {
            labels: data.labels,
            datasets: [{
                label: 'Leads',
                fill: false,
                backgroundColor: 'rgb(54, 162, 235)',
                borderColor: 'rgb(54, 162, 235)',
                data: data.leads
              },
              {
                label: 'Previous period leads',
                fill: false,
                backgroundColor: 'rgb(54, 162, 235)',
                borderColor: 'rgb(54, 162, 235)',
                borderDash: [5, 5],
                data: data.previous_period_leads
              }
            ]
          },
          options: {
            legend: {
              position: 'bottom'
            },
            tooltips: {
              mode: 'index',
              intersect: false
            },
            scales: {
              yAxes: [{
                ticks: {
                  beginAtZero: true,
                  precision: 0
                }
              }]
            }
          }
        });

        $('#statistic_period_for_chart').on('change', function () {
          let $self = $(this);
          $.ajax({
            url: '/api/v1/charts/leads',
            method: 'GET',
            data: {
              number_of_days: $self.val()
            },
            success: function (data) {
              leadsChart.data.labels = data.labels
              leadsChart.data.datasets[0].data = data.leads
              leadsChart.data.datasets[1].data = data.previous_period_leads
              leadsChart.update();
            }
          });
        });
    	}
    });
  }
});


// WEBPACK FOOTER //
// ./app/webpacker/src/js/charts/leads.js